import { TextButton } from '@oneaudi/unified-web-components';
import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { useI18n } from '~/app/i18n/i18n';
import { useMarketConfig } from '~/app/market-config';
import { StockCarEnabled, useStockCarDialog } from '~/app/pages/configurator/components/dialogs/stock-car-dialog';
import { appTrackingService } from '~/app/tracking/app-tracking-service';
import { EventAction } from '~/app/tracking/feld-m-types';
import { useBreakPoint } from '~/hooks/responsive/useBreakPoint';
import { BasicProps } from '~/models/basic-props';
import { state } from '~/storage';
import { DATA_TEST_ID } from '~/test/data-test-id';
import { SummaryCtaButton } from './main-cta-button';
import { UserMarketingStyle } from './styles/user-marketing-style';

export function UserMarketing({ className }: BasicProps) {
	const { config } = useMarketConfig();
	const [currentView, setCurrentView] = useAtom(state.currentView);
	const { i18n } = useI18n();
	const { isCustomBreakpoint } = useBreakPoint('768');
	const { showStockCarDialog } = useStockCarDialog(config.stockCarConfig.geoFilter);

	const handleSummaryClick = useCallback(() => {
		setCurrentView('summary');
		appTrackingService.basketNavigationClick({
			label: i18n('ngc.actions.getYourCar'),
			targetUrl: '#summary',
			targetPage: 'summary',
		});
	}, [i18n, setCurrentView]);

	const handleStockCarClick = useCallback(() => {
		appTrackingService.summaryClickEvent({
			eventAction: EventAction.InternalLink,
			eventName: `configurator (price bar) - click on stock car matching`,
			componentName: 'configurator-price-bar',
			label: i18n('ngc.stockcar.trigger'),
			elementName: 'button',
		});
		showStockCarDialog();
	}, [i18n, setCurrentView]);

	return (
		<UserMarketingStyle className={className}>
			<div className="button-group">
				{StockCarEnabled() && isCustomBreakpoint && (
					<TextButton
						className="main-cta-button"
						type={'button'}
						variant={'secondary'}
						onClick={handleStockCarClick}
						size={'sm'}
						data-testid={DATA_TEST_ID.STOCK_CAR_BUTTON}>
						{i18n('ngc.stockcar.trigger')}
					</TextButton>
				)}
				{currentView === 'summary' ? (
					<SummaryCtaButton variant="primary" size="md" isSecondCta="false" />
				) : (
					<TextButton
						href={'#summary'}
						variant="primary"
						onClick={handleSummaryClick}
						size="sm"
						isFullWidth
						data-testid={DATA_TEST_ID.SUMMARY_BUTTON}>
						{i18n('ngc.actions.getYourCar')}
					</TextButton>
				)}
			</div>
		</UserMarketingStyle>
	);
}
